import * as yup from "yup";

export const RFMlineItemSchema = yup.object().shape({
  particulars: yup.string(),

  itemUnit: yup.string(),

  itemQuantity: yup.string(),
});

export const RFMSchema = yup.object().shape({
  project: yup.string(),

  purposeUse: yup.string().required("Required"),
  notes: yup.string(),
  itemFrom: yup.string(),

  lineItems: yup.array().of(RFMlineItemSchema),
});
